import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api/client'
import type { Meeting } from '../shared/types'

export type MeetingInput = {
  account_id: string
  kind: string
  subject: string
  planned_at: string
  ends_at?: string
  location?: string
  prep_notes?: string
}

export type MeetingUpdate = {
  status?: string
  minutes?: string
  evaluation?: string
  decisions?: string
  materials?: string
}

export const useMeetings = (accountId?: string) =>
  useQuery({
    queryKey: ['meetings', accountId ?? 'all'],
    queryFn: () => api.get<Meeting[]>('/api/v1/meetings', accountId ? { account_id: accountId } : undefined),
  })

export function useCreateMeeting() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: MeetingInput) => api.post<{ id: string }>('/api/v1/meetings', body),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['meetings'] }),
  })
}

export function useUpdateMeeting() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, ...body }: MeetingUpdate & { id: string }) => api.put(`/api/v1/meetings/${id}`, body),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['meetings'] }),
  })
}
